export const translations = {
  tr: {
    nav: {
      home: "Anasayfa",
      services: "Hizmetler",
      about: "Hakkımızda",
      blog: "Blog",
      references: "Referanslar",
      contact: "İletişim",
      cta: "Ücretsiz IT Röntgeni",
    },
    references: {
      tag: "Referanslarımız",
      title: "Güvenen markalar, ölçülebilir sonuçlar",
      desc: "Farklı sektörlerden şirketlerin IT altyapısını dönüştürdük. İşte bazı başarı hikâyeleri.",
      viewAll: "Tüm Referanslar",
      result: "Sonuç",
      readStory: "Hikâyeyi oku",
      story: "Başarı Hikâyesi",
      serviceUsed: "Kullanılan Hizmet",
      website: "Web sitesi",
      others: "Diğer Referanslar",
      backAll: "Tüm Referanslar",
      notFound: "Referans bulunamadı",
      pageTitle: "Referanslar & Başarı Hikâyeleri",
      pageDesc: "Lojistikten sağlığa, hukuktan üretime; farklı sektörlerdeki müşterilerimiz için ürettiğimiz somut sonuçlar.",
      empty: "Bu kategoride henüz referans yok.",
      ctaTitle: "Bir sonraki başarı hikâyesi sizin olsun",
      ctaDesc: "Ücretsiz IT röntgeni ile başlayalım; sizin için de ölçülebilir sonuçlar üretelim.",
      ctaButton: "Ücretsiz Analiz Talep Et",
    },
    faq: {
      tag: "Sık Sorulan Sorular",
      title: "Aklınızdaki sorulara net yanıtlar",
      desc: "IT röntgeni, maliyetler, güvenlik ve çalışma modelimiz hakkında en çok merak edilenler.",
      moreTitle: "Başka bir sorunuz mu var?",
      moreDesc: "Uzman ekibimiz aynı iş günü içinde size dönüş yapar.",
      moreCta: "Bize ulaşın",
      items: [
        {
          q: "Ücretsiz IT röntgeni tam olarak neyi kapsıyor?",
          a: "Ekibimiz şirketinizi yerinde ziyaret eder; sunucu, ağ, güvenlik duvarı, yedekleme, Microsoft 365 lisansları ve cihaz envanterinizi inceler. Sonunda mevcut durumu, riskleri ve önceliklendirilmiş bir yol haritasını içeren yazılı bir rapor alırsınız. Herhangi bir ücret veya taahhüt yoktur.",
        },
        {
          q: "Hangi büyüklükteki şirketlerle çalışıyorsunuz?",
          a: "Genellikle 20 ile 500 kullanıcı arasındaki, çok şubeli veya hızlı büyüyen KOBİ ve orta ölçekli kurumlarla çalışıyoruz. Butik yapımız sayesinde her müşteriye özel, hızlı ve esnek çözümler sunabiliyoruz.",
        },
        {
          q: "Microsoft 365 lisans optimizasyonu ile ne kadar tasarruf sağlanabilir?",
          a: "Kullanım verilerini analiz ederek atıl lisansları temizliyor ve kullanıcıları doğru planlara taşıyoruz. Tipik projelerde yıllık lisans maliyetlerinde %20–35 aralığında tasarruf görülür; kullanıcı deneyimi hiç bozulmaz.",
        },
        {
          q: "Universal Print yazıcı maliyetlerimizi gerçekten düşürür mü?",
          a: "Evet. Tüm lokasyonlardaki yazıcıları bulutta tek noktadan yönetir, sürücü karmaşasını kaldırır ve departman bazlı raporlama sunar. Çok şubeli şirketlerde ilk aylardan itibaren %35–50 baskı maliyeti düşüşü gözlemliyoruz.",
        },
        {
          q: "Siber güvenlik için hangi teknolojileri kullanıyorsunuz?",
          a: "FortiGate güvenlik duvarları ile merkez-şube Zero-Trust mimarisi kuruyor, Intune / Jamf / ManageEngine ile cihaz ve politika yönetimi (MDM/MAM) yapıyor, Synology NAS üzerinde şifreli yedekleme ve felaket kurtarma planı oluşturuyoruz.",
        },
        {
          q: "Kurulum sonrasında destek nasıl işliyor?",
          a: "Devreye alınan tüm sistemler 7/24 proaktif izlemeye alınır. Olası sorunlar siz fark etmeden tespit edilir ve müdahale edilir. Aylık raporlar ve düzenli iyileştirme toplantıları ile altyapınız sürekli güncel tutulur.",
        },
        {
          q: "Verilerimizin bulutta mı yoksa yerelde mi durması gerektiğine nasıl karar veriyorsunuz?",
          a: "Veri sınıflandırması yapıyoruz: erişim sıklığı, yasal gereklilikler (KVKK) ve maliyet dengesine göre hibrit bir mimari öneriyoruz. Sık kullanılan veri Synology NAS üzerinde yerelde, arşiv veri ise Azure/AWS bulutunda tutulabilir.",
        },
        {
          q: "Projeler ne kadar sürer ve iş kesintisi olur mu?",
          a: "Yol haritası kademeli planlanır; her adım mesai dışı saatlerde veya pilot gruplarla uygulanır. Küçük projeler 1–2 hafta, kapsamlı dönüşümler 2–3 ay sürer. Hedefimiz her zaman sıfıra yakın iş kesintisidir.",
        },
      ],
    },
    hero: {
      badge: "Butik IT Ajansı — İstanbul",
      title1: "Dijital Dönüşümde",
      title2: "Butik Hız, Kurumsal Güç",
      desc: "Şirketinizi ziyaret ediyor, IT altyapınızın röntgenini çekiyor, gerçek öncelikleri raporluyoruz. Büyük ajansların hantallığı yok — sadece somut sonuçlar.",
      ctaPrimary: "IT Röntgenimi Çek — Ücretsiz",
      ctaSecondary: "Hizmetleri İncele",
      stat1: "Proaktif İzleme",
      stat2: "İlk Analiz",
      stat3: "Ort. Maliyet Tasarrufu",
      liveTitle: "Canlı Altyapı İzleme",
      liveSub: "7/24 Proaktif Monitöring Aktif",
    },
    partners: {
      title: "Güvenilen Teknolojiler",
    },
    method: {
      tag: "Metodolojimiz",
      title: "Röntgen önce, reçete sonra",
      desc: "Size hazır ürün satmayız. Şirketinizi anlıyor, mevcut durumu raporluyor, en kritik operasyonel sorundan başlıyoruz.",
      steps: [
        {
          no: "01",
          title: "Analiz & Ziyaret",
          desc: "Şirketinizi yerinde ziyaret ediyor, mevcut IT altyapısını, güvenlik açıklarını ve verimsizlik noktalarını belgeliyoruz. Hiçbir maliyet, taahhüt yok.",
        },
        {
          no: "02",
          title: "Raporlama & Önceliklendirme",
          desc: "Var olan durumu eksileri ve artılarıyla önünüze koyuyor, en çok zorlandığınız operasyonel alandan başlayan bir öncelik listesi oluşturuyoruz.",
        },
        {
          no: "03",
          title: "Uygulama & 7/24 İzleme",
          desc: "Onaylanan yol haritasını minimal aksama ile hayata geçiriyor; kurulum sonrasında altyapınızı 7/24 proaktif izlemeye alıyoruz.",
        },
      ],
    },
    servicesOverview: {
      tag: "Çözüm Alanlarımız",
      title: "4 stratejik dikey, uçtan uca çözüm",
      desc: "Kurumsal IT'nin dört kritik ekseninde, strateji ve uygulamayı tek çatı altında topluyoruz.",
      viewAll: "Tüm Hizmetleri Gör",
      learnMore: "Detaylı İncele",
    },
    results: {
      tag: "Somut Sonuçlar",
      title: "Maliyet Tasarrufu & Sürdürülebilirlik",
      desc: "Kurumsal IT yatırımlarınızı optimize ediyor, hem bütçenizi hem de karbon ayak izinizi küçültüyoruz. Rakamlar bunu kanıtlıyor.",
      points: [
        "Universal Print ile çok lokasyonlu şirketlerde yazıcı bütçeleri %35–50 düşüyor.",
        "Microsoft 365 lisans analizi ile ihtiyaç dışı, atıl paketler eleniyor, bütçe optimize ediliyor.",
        "E-imza & sıfır kağıt platformları ile ESG süreçlerinde tam mevzuat uyumluluğu sağlanıyor.",
        "Synology NAS ile güvenli dosya sunucusu kurgulanarak bulut depolama bağımlılığı azaltılıyor.",
      ],
      kpis: [
        { value: "%50", label: "Yazıcı maliyeti düşüşü" },
        { value: "7/24", label: "Proaktif sistem izleme" },
        { value: "0₺", label: "İlk altyapı analizi" },
        { value: "ESG", label: "Yeşil IT & sıfır kağıt" },
      ],
    },
    featured: {
      tag: "Öne Çıkan Çözümler",
      title: "Rakiplerden Ayıran İki Kritik Hizmet",
      card1Tag: "Universal Print & ESG",
      card1Title: "Yazıcı Maliyetlerine Son: Bulut Tabanlı Yazdırma",
      card1Desc: "Onlarca ofis, yüzlerce yazıcı ile kontrolden çıkan maliyetler… Tüm lokasyonlarınızı bulutta tek bir yazıcı gibi yönetin, kimin ne kadar yazdırdığını raporlayın.",
      card1Points: [
        "Tek sürücü — şubeler arası geçişte yeni kurulum gerektirmeden çıktı imkanı",
        "Kullanıcı & departman bazlı anlık maliyet raporlaması",
        "ESG uyumu: sıfır kağıt felsefesi ve e-imza entegrasyonu",
        "Somut ve ölçülebilir bütçe tasarrufu — ilk aydan itibaren",
      ],
      card2Tag: "Power BI & Envanter",
      card2Title: "Şirket Envanteriniz Kontrol Altında",
      card2Desc: "\"Hangi cihaz kimdeydi, hangi lisans boşa çıkıyor?\" sorularına son veriyoruz. İK sisteminizle tam entegre Power BI panelleri inşa ediyoruz.",
      card2Points: [
        "Power Platform ile şirkete özel canlı envanter takip yazılımı",
        "Personel onboarding/offboarding süreçlerinin tam dijitalleşmesi",
        "Personel ayrıldığında tüm cihaz ve lisans haklarının otomatik iadesi",
        "İK entegrasyonu — insan kaynakları ve IT'yi tek platformda birleştirme",
      ],
    },
    process: {
      tag: "Nasıl Çalışıyoruz?",
      title: "Adım adım dijital dönüşüm",
      desc: "Her proje bir analizle başlar. Şirketinizi ziyaret edip önce anlıyor, sonra çözüyoruz.",
      steps: [
        {
          title: "Ücretsiz Altyapı Ziyareti",
          desc: "Ekibimiz şirketinizi yerinde ziyaret eder. Mevcut IT altyapısı, siber güvenlik açıkları ve operasyonel darboğazlar belgelenir.",
        },
        {
          title: "Detaylı Durum Raporu",
          desc: "Tespitler şeffaf bir şekilde raporlanır. Hangi alanlarda risk var, hangi yatırımlar bütçe israfı — net ve anlaşılır sunulur.",
        },
        {
          title: "Öncelikli Yol Haritası",
          desc: "En kritik operasyonel sorundan başlayan, bütçe-etkin ve kademeli bir dönüşüm planı hazırlanır.",
        },
        {
          title: "Uygulama & Sürekli Destek",
          desc: "Onaylanan plan minimal iş kesintisiyle uygulanır; kurulum sonrasında sistemleriniz 7/24 proaktif monitöring ile korunur.",
        },
      ],
    },
    ctaBanner: {
      title: "Şirketinizin IT Röntgenini Çekelim",
      desc: "Mevcut altyapınızı ücretsiz inceliyor ve size özel, maliyet-etkin dijital dönüşüm haritasını çıkarıyoruz.",
      button: "Ücretsiz Analiz Talep Et",
      note: "Taahhüt yok · Satış baskısı yok · Sadece gerçekler",
    },
    servicesPage: {
      hero: "Hizmetlerimiz",
      heroDesc: "Kurumsal IT'nin dört stratejik dikeyinde, strateji ve uygulamayı uçtan uca birleştiriyoruz.",
      includes: "Kapsam",
      ctaTitle: "Hangi hizmete ihtiyacınız olduğundan emin değil misiniz?",
      ctaDesc: "Ücretsiz IT röntgeni ile başlayalım; doğru önceliği birlikte belirleyelim.",
    },
    aboutPage: {
      hero: "Hakkımızda",
      heroDesc: "İşletmelerin dijital dönüşüm süreçlerine öncülük eden, yenilikçi ve güvenilir bir IT teknoloji firması.",
      storyTitle: "Butik yaklaşım, kurumsal disiplin",
      story1: "AdalCrea, büyük ajansların hantal süreçlerinden sıyrılıp, her müşterisine özel çözümler üreten butik bir IT ajansıdır. Şirketinizi ziyaret ediyor, altyapınızın röntgenini çekiyor ve gerçek önceliklerinizi belirliyoruz.",
      story2: "Hazır ürün satmak yerine, işinizi anlayıp size özel bir yol haritası çıkarıyoruz. Kurulum sonrasında altyapınızı 7/24 proaktif izleme ile koruyoruz.",
      valuesTitle: "Değerlerimiz",
      values: [
        { title: "Şeffaflık", desc: "Gizli maliyet ve satış baskısı yok. Yalnızca gerçekler ve ölçülebilir sonuçlar." },
        { title: "Butik Hız", desc: "Küçük, uzman ekip; hızlı karar, hızlı uygulama. Bürokrasi yok." },
        { title: "Sürdürülebilirlik", desc: "Yeşil IT ve sıfır kağıt felsefesiyle karbon ayak izinizi küçültüyoruz." },
        { title: "Güvenlik Önce", desc: "Zero-Trust mimari, sürekli izleme ve iş sürekliliği odaklı yaklaşım." },
      ],
      statsTitle: "Rakamlarla AdalCrea",
    },
    blogPage: {
      hero: "Blog & Kaynaklar",
      heroDesc: "Dijital dönüşüm, siber güvenlik, bulut ve IT maliyet optimizasyonu üzerine uzman içerikler.",
      readMore: "Devamını Oku",
      readTime: "dk okuma",
      related: "İlgili Yazılar",
      back: "Tüm Yazılar",
      all: "Tümü",
    },
    contactPage: {
      hero: "İletişim",
      heroDesc: "Mevcut altyapınızı ücretsiz inceliyor ve size özel dijital dönüşüm haritasını çıkarıyoruz. Formu doldurun, uzmanlarımız en kısa sürede ulaşsın.",
      formTitle: "Ücretsiz Analiz Talebi",
      name: "Ad Soyad",
      company: "Şirket",
      email: "E-posta",
      phone: "Telefon",
      service: "İlgilendiğiniz Hizmet",
      selectService: "Bir hizmet seçin",
      message: "Mesajınız",
      messagePlaceholder: "İhtiyaçlarınızı kısaca anlatın...",
      submit: "Talebi Gönder",
      submitting: "Gönderiliyor...",
      successTitle: "Talebiniz alındı!",
      successMsg: "Teşekkürler, uzmanlarımız en kısa sürede sizinle iletişime geçecek.",
      errorMsg: "Bir hata oluştu. Lütfen tekrar deneyin veya bizi telefonla arayın.",
      infoTitle: "İletişim Bilgileri",
      address: "Zuhuratbaba Mah. Tatlınar Sokak No 2, Bakırköy / İstanbul",
      hours: "Çalışma Saatleri",
      hoursValue: "Pazartesi – Cuma: 09:00 – 18:00",
      required: "Bu alan zorunludur",
      invalidEmail: "Geçerli bir e-posta girin",
      disclaimer: "Bilgileriniz yalnızca sizinle iletişim kurmak amacıyla kullanılır. Üçüncü taraflarla paylaşılmaz.",
    },
    footer: {
      about: "İşletmelerin dijital dönüşüm süreçlerine öncülük eden, yenilikçi ve güvenilir bir IT teknoloji firması.",
      servicesTitle: "HİZMETLER",
      companyTitle: "ŞİRKET",
      legalTitle: "YASAL",
      privacy: "Gizlilik Politikası",
      terms: "Kullanım Koşulları",
      rights: "Tüm hakları saklıdır.",
      location: "İstanbul · Türkiye",
      newsletter: "Bültenimize abone olun",
      subscribe: "Abone Ol",
      emailPlaceholder: "E-posta adresiniz",
    },
  },

  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      blog: "Blog",
      references: "References",
      contact: "Contact",
      cta: "Free IT Assessment",
    },
    references: {
      tag: "Our References",
      title: "Trusted brands, measurable results",
      desc: "We've transformed IT infrastructures for companies across industries. Here are a few success stories.",
      viewAll: "All References",
      result: "Result",
      readStory: "Read the story",
      story: "Success Story",
      serviceUsed: "Service Used",
      website: "Website",
      others: "More References",
      backAll: "All References",
      notFound: "Reference not found",
      pageTitle: "References & Success Stories",
      pageDesc: "From logistics to healthcare, law to manufacturing; the concrete results we've delivered for clients across industries.",
      empty: "No references in this category yet.",
      ctaTitle: "Let the next success story be yours",
      ctaDesc: "Let's start with a free IT X-ray and deliver measurable results for you too.",
      ctaButton: "Request Free Analysis",
    },
    faq: {
      tag: "Frequently Asked Questions",
      title: "Clear answers to your questions",
      desc: "The most common questions about the IT X-ray, costs, security and how we work.",
      moreTitle: "Have another question?",
      moreDesc: "Our expert team gets back to you within the same business day.",
      moreCta: "Contact us",
      items: [
        {
          q: "What exactly does the free IT X-ray cover?",
          a: "Our team visits your company on-site and reviews your servers, network, firewall, backups, Microsoft 365 licenses and device inventory. You receive a written report covering the current state, risks and a prioritized roadmap. There is no fee or commitment.",
        },
        {
          q: "What size of companies do you work with?",
          a: "We typically work with SMEs and mid-sized organizations of 20 to 500 users, especially multi-branch or fast-growing companies. Our boutique structure lets us deliver tailored, fast and flexible solutions to every client.",
        },
        {
          q: "How much can Microsoft 365 license optimization save?",
          a: "We analyze usage data, clean up idle licenses and move users to the right plans. Typical projects see 20–35% savings on annual license costs with zero impact on user experience.",
        },
        {
          q: "Does Universal Print really reduce our printing costs?",
          a: "Yes. It manages printers across all locations from a single cloud point, removes driver chaos and provides department-level reporting. In multi-branch companies we observe 35–50% printing cost reductions from the first months.",
        },
        {
          q: "Which technologies do you use for cyber security?",
          a: "We build HQ-branch Zero-Trust architectures with FortiGate firewalls, manage devices and policies (MDM/MAM) with Intune / Jamf / ManageEngine, and set up encrypted backups and disaster recovery plans on Synology NAS.",
        },
        {
          q: "How does support work after deployment?",
          a: "All deployed systems are placed under 24/7 proactive monitoring. Potential issues are detected and resolved before you notice them. Monthly reports and regular improvement meetings keep your infrastructure up to date.",
        },
        {
          q: "How do you decide whether our data should be in the cloud or on-premises?",
          a: "We classify your data and recommend a hybrid architecture based on access frequency, legal requirements (GDPR/KVKK) and cost balance. Frequently used data can stay local on Synology NAS while archive data lives in Azure/AWS.",
        },
        {
          q: "How long do projects take and will there be downtime?",
          a: "The roadmap is planned in phases; each step is executed outside business hours or with pilot groups. Small projects take 1–2 weeks, comprehensive transformations 2–3 months. Our goal is always near-zero business disruption.",
        },
      ],
    },
    hero: {
      badge: "Boutique IT Agency — Istanbul",
      title1: "Boutique Speed,",
      title2: "Enterprise Power in Digital Transformation",
      desc: "We visit your company, run a full X-ray of your IT infrastructure and report the real priorities. None of the bureaucracy of big agencies — just concrete results.",
      ctaPrimary: "Get My Free IT X-Ray",
      ctaSecondary: "Explore Services",
      stat1: "Proactive Monitoring",
      stat2: "First Assessment",
      stat3: "Avg. Cost Savings",
      liveTitle: "Live Infrastructure Monitoring",
      liveSub: "24/7 Proactive Monitoring Active",
    },
    partners: {
      title: "Trusted Technologies",
    },
    method: {
      tag: "Our Methodology",
      title: "Diagnosis first, prescription later",
      desc: "We don't sell you off-the-shelf products. We understand your company, report the current state and start from the most critical operational issue.",
      steps: [
        {
          no: "01",
          title: "Analysis & Visit",
          desc: "We visit your company on-site and document the current IT infrastructure, security gaps and inefficiencies. No cost, no commitment.",
        },
        {
          no: "02",
          title: "Reporting & Prioritization",
          desc: "We present the current state with its pros and cons, and build a priority list starting from your most challenging operational area.",
        },
        {
          no: "03",
          title: "Implementation & 24/7 Monitoring",
          desc: "We execute the approved roadmap with minimal disruption; after deployment your infrastructure is placed under 24/7 proactive monitoring.",
        },
      ],
    },
    servicesOverview: {
      tag: "Our Solution Areas",
      title: "4 strategic verticals, end-to-end solutions",
      desc: "Across the four critical axes of enterprise IT, we combine strategy and implementation under one roof.",
      viewAll: "View All Services",
      learnMore: "Learn More",
    },
    results: {
      tag: "Concrete Results",
      title: "Cost Savings & Sustainability",
      desc: "We optimize your enterprise IT investments, shrinking both your budget and your carbon footprint. The numbers prove it.",
      points: [
        "With Universal Print, printing budgets in multi-location companies drop by 35–50%.",
        "Microsoft 365 license analysis eliminates unnecessary, idle packages and optimizes the budget.",
        "E-signature & paperless platforms ensure full regulatory compliance in ESG processes.",
        "With Synology NAS, a secure file server reduces cloud storage dependency.",
      ],
      kpis: [
        { value: "50%", label: "Printing cost reduction" },
        { value: "24/7", label: "Proactive system monitoring" },
        { value: "$0", label: "First infrastructure analysis" },
        { value: "ESG", label: "Green IT & paperless" },
      ],
    },
    featured: {
      tag: "Featured Solutions",
      title: "Two Critical Services That Set Us Apart",
      card1Tag: "Universal Print & ESG",
      card1Title: "End Printing Costs: Cloud-Based Printing",
      card1Desc: "Dozens of offices, hundreds of printers with runaway costs… Manage all your locations in the cloud as a single printer and report who prints how much.",
      card1Points: [
        "One driver — print across branches with no new setup when switching locations",
        "Real-time cost reporting per user & department",
        "ESG compliance: paperless philosophy and e-signature integration",
        "Concrete and measurable budget savings — from the first month",
      ],
      card2Tag: "Power BI & Inventory",
      card2Title: "Your Company Inventory Under Control",
      card2Desc: "We put an end to \"Which device did who have, which license is idle?\" questions. We build Power BI dashboards fully integrated with your HR system.",
      card2Points: [
        "Custom live inventory tracking software with Power Platform",
        "Full digitalization of staff onboarding/offboarding processes",
        "Automatic return of all device and license rights when staff leave",
        "HR integration — unifying human resources and IT on a single platform",
      ],
    },
    process: {
      tag: "How We Work",
      title: "Step-by-step digital transformation",
      desc: "Every project starts with an analysis. We visit your company, understand first, then solve.",
      steps: [
        {
          title: "Free Infrastructure Visit",
          desc: "Our team visits your company on-site. Current IT infrastructure, cyber security gaps and operational bottlenecks are documented.",
        },
        {
          title: "Detailed Status Report",
          desc: "Findings are reported transparently. Where the risks are, which investments waste budget — presented clearly and understandably.",
        },
        {
          title: "Prioritized Roadmap",
          desc: "A budget-effective, phased transformation plan is prepared, starting from the most critical operational issue.",
        },
        {
          title: "Implementation & Ongoing Support",
          desc: "The approved plan is implemented with minimal business disruption; after deployment your systems are protected with 24/7 proactive monitoring.",
        },
      ],
    },
    ctaBanner: {
      title: "Let's Run Your Company's IT X-Ray",
      desc: "We assess your current infrastructure for free and produce a custom, cost-effective digital transformation roadmap.",
      button: "Request Free Analysis",
      note: "No commitment · No sales pressure · Just facts",
    },
    servicesPage: {
      hero: "Our Services",
      heroDesc: "Across the four strategic verticals of enterprise IT, we unite strategy and implementation end-to-end.",
      includes: "Scope",
      ctaTitle: "Not sure which service you need?",
      ctaDesc: "Let's start with a free IT X-ray and define the right priority together.",
    },
    aboutPage: {
      hero: "About Us",
      heroDesc: "An innovative and reliable IT technology company leading businesses through their digital transformation journeys.",
      storyTitle: "Boutique approach, enterprise discipline",
      story1: "AdalCrea is a boutique IT agency that breaks away from the bureaucratic processes of big agencies to deliver tailored solutions to every client. We visit your company, run an X-ray of your infrastructure and identify your real priorities.",
      story2: "Instead of selling off-the-shelf products, we understand your business and build a roadmap specific to you. After deployment, we protect your infrastructure with 24/7 proactive monitoring.",
      valuesTitle: "Our Values",
      values: [
        { title: "Transparency", desc: "No hidden costs or sales pressure. Only facts and measurable results." },
        { title: "Boutique Speed", desc: "Small, expert team; fast decisions, fast execution. No bureaucracy." },
        { title: "Sustainability", desc: "We shrink your carbon footprint with a green IT and paperless philosophy." },
        { title: "Security First", desc: "Zero-Trust architecture, continuous monitoring and a business-continuity focus." },
      ],
      statsTitle: "AdalCrea in Numbers",
    },
    blogPage: {
      hero: "Blog & Resources",
      heroDesc: "Expert content on digital transformation, cyber security, cloud and IT cost optimization.",
      readMore: "Read More",
      readTime: "min read",
      related: "Related Articles",
      back: "All Articles",
      all: "All",
    },
    contactPage: {
      hero: "Contact",
      heroDesc: "We assess your current infrastructure for free and produce a custom digital transformation roadmap. Fill in the form and our experts will reach out shortly.",
      formTitle: "Request a Free Analysis",
      name: "Full Name",
      company: "Company",
      email: "Email",
      phone: "Phone",
      service: "Service of Interest",
      selectService: "Select a service",
      message: "Your Message",
      messagePlaceholder: "Briefly describe your needs...",
      submit: "Send Request",
      submitting: "Sending...",
      successTitle: "Request received!",
      successMsg: "Thank you, our experts will contact you shortly.",
      errorMsg: "Something went wrong. Please try again or call us.",
      infoTitle: "Contact Information",
      address: "Zuhuratbaba Mah. Tatlinar Sokak No 2, Bakirkoy / Istanbul",
      hours: "Working Hours",
      hoursValue: "Monday – Friday: 09:00 – 18:00",
      required: "This field is required",
      invalidEmail: "Enter a valid email",
      disclaimer: "Your information is used solely to contact you. It is never shared with third parties.",
    },
    footer: {
      about: "An innovative and reliable IT technology company leading businesses through their digital transformation journeys.",
      servicesTitle: "SERVICES",
      companyTitle: "COMPANY",
      legalTitle: "LEGAL",
      privacy: "Privacy Policy",
      terms: "Terms of Use",
      rights: "All rights reserved.",
      location: "Istanbul · Turkey",
      newsletter: "Subscribe to our newsletter",
      subscribe: "Subscribe",
      emailPlaceholder: "Your email address",
    },
  },
};
